import React from 'react';
import CopyableValue from '../common/CopyableValue';

const DetailGroup = ({ title, items }) => (
  <div className={title ? "pt-1.5" : ""}>
    {title && (
      <div className="flex items-center gap-2 text-xs">
        <span className="text-slate-400 uppercase tracking-wider font-medium">{title}</span>
        <div className="h-px flex-1 bg-white/5 mr-[17px]" />
      </div>
    )}
    <div className={`${title ? 'mt-1.5 ' : ''}flex flex-col leading-none`}>
      {items.map((item, index) => (
        <CopyableValue
          key={index}
          value={item.value}
          label={`${title} - ${item.label}`}
          preserveFormatting
          className="w-full block leading-none"
          size="small"
          showTooltip={true}
        >
          <div className="flex justify-between text-xs cursor-pointer hover:bg-slate-800/40 rounded transition-colors w-full leading-none py-1">
            <span className="text-slate-500 tracking-wide">{item.label}</span>
            <span className={`text-slate-400 tracking-wide ml-auto ${item.value === '--' ? 'dashes' : ''} ${item.className || ''}`}>
              {item.value}
            </span>
          </div>
        </CopyableValue>
      ))}
    </div>
  </div>
);

export default DetailGroup;